module.exports = __webpack_public_path__ + "img/ic_em.44b034a9.svg";